import type { Opportunity, WhatsappMessageDraft } from './types'

/**
 * WhatsappService — message drafting + future WhatsApp API architecture.
 * Official API is NOT implemented yet.
 */
export class WhatsappService {
  buildFollowUpMessage(opportunity: Opportunity): WhatsappMessageDraft {
    const name = opportunity.customerName ?? 'Cliente'
    const body = [
      `Olá ${name}!`,
      '',
      'Tudo bem?',
      '',
      'Há alguns dias enviamos seu orçamento.',
      '',
      'Gostaria de saber se conseguiu analisar ou se possui alguma dúvida.',
      '',
      'Estamos à disposição.',
      '',
      'Master Informática',
    ].join('\n')

    return {
      opportunityId: opportunity.id,
      customerName: name,
      phone: opportunity.customerPhone,
      body,
      channel: 'whatsapp',
      preparedFor: 'whatsapp-api',
    }
  }

  /** Opens wa.me deep link when phone is available (no official API). */
  openDraft(draft: WhatsappMessageDraft): { ok: boolean; url: string | null; message: string } {
    const digits = (draft.phone ?? '').replace(/\D/g, '')
    if (!digits) {
      return {
        ok: false,
        url: null,
        message: 'Telefone/WhatsApp do cliente não cadastrado',
      }
    }
    const phone = digits.startsWith('55') ? digits : `55${digits}`
    const url = `https://wa.me/${phone}?text=${encodeURIComponent(draft.body)}`
    if (typeof window !== 'undefined') {
      window.open(url, '_blank', 'noopener,noreferrer')
    }
    return { ok: true, url, message: 'Mensagem preparada para WhatsApp' }
  }

  /** Architecture stubs for future channels */
  prepareEmailIntegration(draft: WhatsappMessageDraft) {
    return { channel: 'email', subject: `Orçamento ${draft.customerName}`, body: draft.body }
  }

  prepareAiAssist(draft: WhatsappMessageDraft) {
    return { channel: 'ai', prompt: `Melhore a mensagem comercial: ${draft.body}` }
  }

  prepareGoogleCalendar(opportunityId: string, nextContact: string | null) {
    return { channel: 'google-calendar', opportunityId, nextContact }
  }

  prepareOutlook(opportunityId: string, nextContact: string | null) {
    return { channel: 'microsoft-outlook', opportunityId, nextContact }
  }
}

export const whatsappService = new WhatsappService()
